// src/tiptap/FontSize.js
import TextStyle from '@tiptap/extension-text-style';

export const FontSize = TextStyle.extend({
    // ★ 이름은 그대로 'textStyle' 이어야 기존 마크를 확장합니다
    name: 'textStyle',

    addAttributes() {
        return {
            // 새 attribute: fontSize
            fontSize: {
                default: null,
                parseHTML: el => el.style.fontSize || null,
                renderHTML: attrs =>
                    attrs.fontSize ? { style: `font-size:${attrs.fontSize}` } : {},
            },
        };
    },

    addCommands() {
        return {
            setFontSize:
                size => ({ chain }) =>
                    chain().setMark('textStyle', { fontSize: size }).run(),

            unsetFontSize:
                () => ({ chain }) =>
                    chain().setMark('textStyle', { fontSize: null }).run(),
        };
    },
});
